import { memo } from 'react';
import { Scroller, cn } from '@divlab/divanui';

import InputSearch from '../InputSearch';
import styles from './PopupOnMap.module.css';

import type { FC, HTMLAttributes, ReactChild } from 'react';

export interface PopupOnMapProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  className?: string;
  title?: ReactChild;
  infoText?: string;
  cnScroller?: string;
  hasSearch?: boolean;
  searchParamsValue?: string;
  onChangeParams?: (params: string) => void;
}

const PopupOnMap: FC<PopupOnMapProps> = (props) => {
  const {
    className,
    title,
    infoText,
    cnScroller,
    children,
    hasSearch,
    searchParamsValue,
    onChangeParams,
    ...restProps
  } = props;

  return (
    <div {...restProps} className={cn(styles.popupOnMap, className)}>
      <div className={styles.head}>
        {typeof title === 'object' && title}
        {hasSearch && (
          <InputSearch
            className={cn({ [styles.searchInput]: !infoText })}
            searchParamsValue={searchParamsValue}
            onChangeParams={onChangeParams}
          />
        )}
      </div>

      {infoText && <div className={styles.infoLine}>{infoText}</div>}

      <Scroller
        className={cn(styles.scroller, cnScroller)}
        cnContainer={styles.scrollerContainer}
        hideOnMobile={false}
      >
        <div className={styles.insideScroller}>{children}</div>
      </Scroller>
    </div>
  );
};

export default memo(PopupOnMap);
